import React from 'react';
import styles from './PaymentSteps.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import { useSelector } from 'react-redux';
import CircularProgress from './circularProgress/CircularProgress';
import Alert from '@/components/UI/alert/Alert';
import Spinner from '@/components/UI/spinner/Spinner';
const PaymentSteps = () => {
  const proformaState = useSelector((state: {
    proforma;
  }) => state.proforma);
  const stepPercent = 100 / proformaState?.data?.payment_steps?.length;
  return <Box className={styles['payment-steps-container']} data-sentry-element="Box" data-sentry-component="PaymentSteps" data-sentry-source-file="PaymentSteps.tsx">
      <Typography variant="bodyL_Bold" className={styles['header']} data-sentry-element="Typography" data-sentry-source-file="PaymentSteps.tsx">
        مراحل پرداخت
      </Typography>
      {proformaState.loading ? <Box className={styles['circular-progress']}>
          <Spinner color="primary_main" />
        </Box> : <>
          <Box className={styles['steps-container']}>
            {proformaState?.data?.payment_steps?.map((step, index) => <Box className={styles['step']} key={'PAYMENT_STEP_' + index}>
                <CircularProgress progress={(index + 1) * stepPercent} stepNumber={index + 1} />
                <Box className={styles['details']}>
                  <Box className={styles['step-content']}>
                    <Typography variant="bodyM_Bold" className={styles['step-title']}>
                      {step.title}
                    </Typography>
                    <Typography variant="bodyM" className={styles['step-description']}>
                      {step.description}
                    </Typography>
                  </Box>
                  <Box className={styles['price-section']}>
                    <Typography component="span" variant="bodyL_Bold" className={styles['amount']}>
                      {step.final_price.toLocaleString()}
                    </Typography>
                    <Typography variant="bodyM" className={styles['currency']}>{` تومان `}</Typography>
                  </Box>
                </Box>
              </Box>)}
          </Box>
          <Alert title="برای نهایی کردن رزرو خود تنها لازم است پرداخت اول را انجام دهید. " type="warning" icon="info-circle" />
        </>}
    </Box>;
};
export default PaymentSteps;